$(function () {
    // --- Globals and Helpers ---
    let markers = {};
    let markerCounter = 0;
    // Editor pages (add_to_package / edit_signs / template add-document) carry a
    // #signatures-settings container; read-only preview pages (packages/view,
    // signer document) do not. Marker dragging is enabled only in the editor.
    const IS_EDITOR = $('#signatures-settings').length > 0;
    const placeholder = $('<div style="text-align:center;color:red;border: 1px dashed red; pointer-events: none; position: absolute; display: none;">Podpis</div>').appendTo('body');

    // Placement type on add/edit pages: 'sign' | 'variable' | 'manual'.
    function getActivePlacementType() {
        const checked = document.querySelector('input[name="placement_type"]:checked');
        return checked ? checked.value : 'sign';
    }

    // Build grouped <optgroup> HTML for the variable catalog (window.MSIGN_VARIABLES),
    // optionally pre-selecting a key.
    function buildVariableOptionsHtml(selectedKey) {
        const groups = window.MSIGN_VARIABLES || [];
        let html = '';
        groups.forEach(function (group) {
            html += '<optgroup label="' + group.group + '">';
            (group.items || []).forEach(function (item) {
                const sel = item.key === selectedKey ? ' selected' : '';
                html += '<option value="' + item.key + '" data-value="' + $('<div>').text(item.value || '').html() + '"' + sel + '>' + item.label + '</option>';
            });
            html += '</optgroup>';
        });
        return html;
    }

    // --- "Seznam položek OP" table variable ---
    function itemsCfg() {
        return window.MSIGN_ITEMS || { key: 'businessCase.items_table', columns: [], defaults: {} };
    }
    function isItemsKey(key) {
        return key === itemsCfg().key;
    }
    // Look up the catalog "type" of a variable key (from window.MSIGN_VARIABLES).
    function variableTypeForKey(key) {
        const groups = window.MSIGN_VARIABLES || [];
        for (let i = 0; i < groups.length; i++) {
            const items = groups[i].items || [];
            for (let j = 0; j < items.length; j++) {
                if (items[j].key === key) return items[j].type || 'text';
            }
        }
        return 'text';
    }
    // Column checkboxes for a table element's card (names mirror the PHP side).
    function itemsCheckboxesHtml(markerId, options) {
        const cfg = itemsCfg();
        const opts = options || cfg.defaults || {};
        let rows = '';
        (cfg.columns || []).forEach(function (col) {
            const checked = opts[col.key] ? ' checked' : '';
            const name = 'MsignatureDocumentVariable[' + markerId + '][options][' + col.key + ']';
            rows += '<div class="col-6"><div class="form-check">' +
                '<input type="checkbox" class="form-check-input var-items-col" value="1" name="' + name + '"' + checked + '>' +
                '<label class="form-check-label small">' + col.label + '</label>' +
                '</div></div>';
        });
        return '<div class="row g-1 mt-2 var-items-options"><label class="form-label mb-0 small">Sloupce tabulky</label>' + rows + '</div>';
    }
    // Read the checked column options out of a card into a {col: bool} map.
    function itemsOptionsFromCard(card) {
        const opts = {};
        (itemsCfg().columns || []).forEach(function (col) { opts[col.key] = false; });
        card.find('.var-items-col:checked').each(function () {
            const m = ($(this).attr('name') || '').match(/\[options\]\[([^\]]+)\]/);
            if (m) opts[m[1]] = true;
        });
        return opts;
    }
    // A small placeholder table reflecting the enabled columns (dummy rows), used
    // as the on-page preview since a template has no concrete data.
    function buildItemsPlaceholderHtml(options) {
        const opts = options || itemsCfg().defaults || {};
        const heads = [];
        if (opts.code) heads.push('Kód');
        heads.push('Název');
        if (opts.count) heads.push('Počet');
        if (opts.price) heads.push('Cena/MJ');
        if (opts.price_vat) heads.push('Cena/MJ s DPH');
        if (opts.total) heads.push('Celkem');
        if (opts.total_vat) heads.push('Celkem s DPH');

        const th = 'style="border-bottom:1px solid #999;padding:1px 4px;text-align:left;"';
        let head = '<tr>';
        heads.forEach(function (h) { head += '<th ' + th + '>' + h + '</th>'; });
        head += '</tr>';

        const td = 'style="padding:1px 4px;color:#666;"';
        let body = '';
        for (let r = 1; r <= 2; r++) {
            body += '<tr>';
            heads.forEach(function (h, idx) {
                body += '<td ' + td + '>' + (idx === (opts.code ? 1 : 0) ? 'Položka ' + r : '…') + '</td>';
            });
            body += '</tr>';
        }
        if (opts.summary && (opts.total || opts.total_vat)) {
            body += '<tr><td ' + td + ' colspan="' + heads.length + '"><strong>Celkem …</strong></td></tr>';
        }
        return '<table style="width:100%;border-collapse:collapse;">' + head + body + '</table>';
    }

    function variableValueForKey(key) {
        const groups = window.MSIGN_VARIABLES || [];
        for (let i = 0; i < groups.length; i++) {
            const items = groups[i].items || [];
            for (let j = 0; j < items.length; j++) {
                if (items[j].key === key) return items[j].value || '';
            }
        }
        return '';
    }

    // --- Per-element text styling (font / size / color) for variable & manual boxes ---
    function msignStyleCfg() {
        return window.MSIGN_STYLE || { fonts: {}, colors: {}, defaultFont: 'dejavusans', defaultColor: '#000000', defaultSize: 10, min: 7, max: 20 };
    }
    // Marker outline colours: signatures red, entity variables blue, manual text green.
    function variableBorderColor(type) {
        return type === 'manual' ? '#198754' : '#0d6efd';
    }
    // A small grip on the right edge of a variable/manual box; dragging it resizes
    // the box width (persisted as width_mm) so long values fit on one line.
    function makeResizeHandle(color) {
        return $('<span class="marker-resize-handle"></span>').css({
            position: 'absolute', right: '-4px', top: '50%', transform: 'translateY(-50%)',
            width: '8px', height: '16px', background: color, cursor: 'ew-resize',
            'pointer-events': 'auto', 'border-radius': '2px', opacity: 0.85
        });
    }
    // Resolve a marker DOM element to its card key (new markerId or existing uuid).
    function markerKey(marker) {
        const domId = marker.attr('id') || '';
        if (domId.indexOf('existing-marker-') === 0) return domId.slice('existing-marker-'.length);
        if (domId.indexOf('marker-') === 0) return domId.slice('marker-'.length);
        return null;
    }
    function cssFontFamily(font) {
        switch (font) {
            case 'dejavuserif':
            case 'times': return "Georgia, 'Times New Roman', serif";
            case 'dejavusansmono':
            case 'courier': return "'Courier New', monospace";
            default: return 'Helvetica, Arial, sans-serif';
        }
    }
    function buildStyleControls(id, sel) {
        const cfg = msignStyleCfg();
        sel = sel || {};
        const font = sel.font || cfg.defaultFont;
        const size = sel.size || cfg.defaultSize;
        const color = sel.color || cfg.defaultColor;
        let fo = '';
        Object.keys(cfg.fonts).forEach(function (k) { fo += '<option value="' + k + '"' + (k === font ? ' selected' : '') + '>' + cfg.fonts[k] + '</option>'; });
        let co = '';
        Object.keys(cfg.colors).forEach(function (k) { co += '<option value="' + k + '"' + (k === color ? ' selected' : '') + '>' + cfg.colors[k] + '</option>'; });
        return '<div class="row g-1 mt-2">' +
            '<div class="col"><select name="MsignatureDocumentVariable[' + id + '][font_family]" class="form-select form-select-sm var-font" title="Písmo">' + fo + '</select></div>' +
            '<div class="col-auto"><input type="number" min="' + cfg.min + '" max="' + cfg.max + '" name="MsignatureDocumentVariable[' + id + '][font_size]" class="form-control form-control-sm var-size" title="Velikost (px)" value="' + size + '" style="width:72px"></div>' +
            '<div class="col"><select name="MsignatureDocumentVariable[' + id + '][font_color]" class="form-select form-select-sm var-color" title="Barva">' + co + '</select></div>' +
            '</div>';
    }
    function applyMarkerStyle(id, font, size, color) {
        $('#marker-' + id + ', #existing-marker-' + id).css({
            'font-family': cssFontFamily(font),
            'font-size': ((parseInt(size, 10) || 10)) + 'px',
            'color': color || '#000000'
        });
    }

    // The server render resolution for lazily-loaded package pages. Used to
    // derive a page's true size in mm from the rendered PNG's natural pixel size
    // (px / dpi * 25.4) when the server didn't emit explicit page dimensions.
    const PAGE_RENDER_DPI = 150;

    function renderSignaturesForPage(pageElement) {
        if (pageElement.data('signatures-rendered')) return;
        const img = pageElement.find('img');
        const imgEl = img[0];
        let original_width_mm = pageElement.data('original-width-mm');
        let original_height_mm = pageElement.data('original-height-mm');
        // Lazy per-page previews (packages/view) omit server dimensions; derive
        // them from the rendered image once it has loaded.
        if (!original_width_mm || !original_height_mm) {
            if (!imgEl || !imgEl.naturalWidth) return; // image not loaded yet
            original_width_mm = (imgEl.naturalWidth / PAGE_RENDER_DPI) * 25.4;
            original_height_mm = (imgEl.naturalHeight / PAGE_RENDER_DPI) * 25.4;
        }
        const displayed_width_px = img.width();
        const displayed_height_px = img.height();
        if (displayed_width_px === 0) return;

        pageElement.find('.signature-marker-data').each(function() {
            const dataDiv = $(this);
            const uuid = dataDiv.data('uuid');
            const pos_x_mm = dataDiv.data('pos-x-mm');
            const pos_y_mm = dataDiv.data('pos-y-mm');
            const marker_width_mm = dataDiv.data('width-mm');
            const marker_height_mm = dataDiv.data('height-mm');
            const text = dataDiv.data('text');
            const marker_width_px = (marker_width_mm / original_width_mm) * displayed_width_px;
            const marker_height_px = (marker_height_mm / original_height_mm) * displayed_height_px;
            const marker_x_px = (pos_x_mm / original_width_mm) * displayed_width_px;
            const marker_y_px = (pos_y_mm / original_height_mm) * displayed_height_px;
            const marker_top_px = marker_y_px - marker_height_px;
            const marker_left_px = marker_x_px;

            const marker = $('<div style="text-align:center;color:red;font-size:10px;line-height:1.2;overflow:hidden;">' + text + '</div>')
                .addClass('existing-click-marker').attr('id', 'existing-marker-' + uuid)
                .css({
                    position: 'absolute', left: marker_left_px + 'px', top: marker_top_px + 'px',
                    width: marker_width_px + 'px', height: marker_height_px + 'px',
                    border: '1px solid red',
                    'pointer-events': IS_EDITOR ? 'auto' : 'none',
                    cursor: IS_EDITOR ? 'move' : 'default'
                });
            pageElement.append(marker);
        });

        // Variable boxes use a top-left convention (pos_x/pos_y is the top-left
        // corner) and render their resolved text, so the placer sees the filled
        // document.
        pageElement.find('.variable-marker-data').each(function () {
            const dataDiv = $(this);
            const uuid = dataDiv.data('uuid');
            const pos_x_mm = dataDiv.data('pos-x-mm');
            const pos_y_mm = dataDiv.data('pos-y-mm');
            const marker_width_mm = dataDiv.data('width-mm');
            const text = dataDiv.data('value');
            const font = dataDiv.data('font');
            const size = dataDiv.data('size');
            const color = dataDiv.data('color');
            const isItems = !!dataDiv.data('items');
            const varKind = dataDiv.data('variable-kind') === 'manual' ? 'manual' : 'variable';
            const marker_width_px = (marker_width_mm / original_width_mm) * displayed_width_px;
            const marker_left_px = (pos_x_mm / original_width_mm) * displayed_width_px;
            const marker_top_px = (pos_y_mm / original_height_mm) * displayed_height_px;

            const marker = $('<div class="var-marker"></div>')
                .addClass('existing-click-marker').attr('id', 'existing-marker-' + uuid)
                .css({
                    position: 'absolute', left: marker_left_px + 'px', top: marker_top_px + 'px',
                    width: marker_width_px + 'px',
                    color: color || '#000000', fontSize: ((parseInt(size, 10) || 10)) + 'px', 'font-family': cssFontFamily(font),
                    lineHeight: '1.2',
                    // Only outline in the editor; the read-only signer/preview view
                    // shows the filled value with no box.
                    border: IS_EDITOR ? '1px dashed ' + variableBorderColor(varKind) : 'none',
                    'pointer-events': IS_EDITOR ? 'auto' : 'none',
                    cursor: IS_EDITOR ? 'move' : 'default'
                });
            const labelSpan = $('<span class="marker-label"></span>');
            if (isItems) {
                labelSpan.html(buildItemsPlaceholderHtml(dataDiv.data('options') || {}));
            } else {
                labelSpan.text(text || '');
            }
            marker.append(labelSpan);
            if (IS_EDITOR) { marker.append(makeResizeHandle(variableBorderColor(varKind))); }
            pageElement.append(marker);
        });
        pageElement.data('signatures-rendered', true);
    }

    // For lazily-loaded package pages, set the <img> src the first time its page
    // is shown (the server emits data-page-src but no src). When it finishes
    // loading, (re)render the markers for that page — their geometry depends on
    // the image's rendered size, which is only known after load.
    function ensurePageImage(pageElement) {
        const img = pageElement.find('img');
        const imgEl = img[0];
        if (!imgEl) return;
        const lazySrc = img.attr('data-page-src');
        if (!lazySrc) return; // eager (base64) page, nothing to do
        if (!img.attr('src')) {
            img.one('load.msignpage', function () {
                pageElement.removeData('signatures-rendered');
                renderSignaturesForPage(pageElement);
            }).on('error.msignpage', function () {
                img.replaceWith('<div class="alert alert-danger">Stránku se nepodařilo načíst.</div>');
            });
            img.attr('src', lazySrc);
        }
    }

    function initializePdfSlider(slider) {
        if (!slider.length || slider.data('initialized')) return;

        const pages = slider.find('.pdf-page');
        pages.css('position', 'relative');
        // Buttons can be either id-based (single-slider page like add_to_package)
        // or class-based (multi-slider pages like packages/view, signer document).
        const prevBtn = slider.find('.prev-page-btn, #prev-page');
        const nextBtn = slider.find('.next-page-btn, #next-page');
        const pageCounter = slider.find('.page-counter, #page-counter');
        let currentPage = 1;
        const totalPages = pages.length;

        function updateSlider() {
            pages.hide();
            const currentPageElement = pages.filter('[data-page_number="' + currentPage + '"]').show();
            ensurePageImage(currentPageElement);
            renderSignaturesForPage(currentPageElement);
            pageCounter.text(currentPage + '/' + totalPages);
            prevBtn.prop('disabled', currentPage === 1);
            nextBtn.prop('disabled', currentPage === totalPages);
            slider.data('current-page', currentPage);
        }
        prevBtn.on('click', function (e) { e.preventDefault(); if (currentPage > 1) { currentPage--; updateSlider(); } });
        nextBtn.on('click', function (e) { e.preventDefault(); if (currentPage < totalPages) { currentPage++; updateSlider(); } });
        if (totalPages > 0) { updateSlider(); } else { slider.hide(); }
        slider.data('initialized', true);
        slider.data('rerender', updateSlider);
    }

    function initializeAllPdfSliders() {
        markerCounter = $('.signature-marker-data').length;
        $('#pdf-preview-slider, .pdf-preview-slider').each(function () {
            initializePdfSlider($(this));
        });
    }

    // Lazy-load a document preview (packages/view). The preview is rasterized
    // server-side via Imagick which is slow, so each tab fetches its own preview
    // only when first shown — a big package no longer rasterizes every PDF on
    // page load (which caused timeouts).
    function loadLazyPreview(container) {
        const $c = $(container);
        if (!$c.length || $c.data('loaded')) return;
        const url = $c.data('preview-url');
        if (!url) return;
        $c.data('loaded', 1);
        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (r) { return r.text(); })
            .then(function (html) {
                $c.html(html);
                // Pages load individually (ensurePageImage), and each page
                // re-renders its markers once its image finishes loading.
                initializeAllPdfSliders();
            })
            .catch(function (err) {
                console.error('Preview fetch error:', err);
                $c.data('loaded', 0);
                $c.html('<div class="alert alert-danger">Náhled se nepodařilo načíst.</div>');
            });
    }

    // Hidden tabs report width=0, so renderSignaturesForPage early-exits and
    // markers never get drawn. When the tab becomes visible, lazy-load its
    // preview (if not yet loaded) and replay marker rendering for its sliders.
    $(document).on('shown.bs.tab', function (e) {
        const target = $(e.target).attr('href');
        if (!target) return;
        const $target = $(target);
        $target.find('.msign-lazy-preview').each(function () { loadLazyPreview(this); });
        $target.find('#pdf-preview-slider, .pdf-preview-slider').each(function () {
            const slider = $(this);
            slider.find('.pdf-page').removeData('signatures-rendered');
            const rerender = slider.data('rerender');
            if (typeof rerender === 'function') {
                rerender();
            }
        });
    });

    // --- Page Initializer ---
    initializeAllPdfSliders();
    // Load the preview for the initially-active tab (others load on tab show).
    $('.tab-pane.active .msign-lazy-preview, .tab-content > .active .msign-lazy-preview').each(function () { loadLazyPreview(this); });

    // --- Event Handlers ---

    // 1. Handler for custom PDF upload on create page
    const fileInput = $('#msignaturedocument-file');
    if (fileInput.length) {
        const uploadUrl = fileInput.data('upload-url');
        const previewUrl = fileInput.data('preview-url');
        fileInput.on('change', function(e) {
            const file = e.target.files[0];
            if (!file) return;
            if (file.type !== 'application/pdf') {
                bootbox.alert('Chyba: Lze nahrát pouze soubory typu PDF.');
                $(this).val(''); return;
            }
            if (file.size > 10 * 1024 * 1024) {
                bootbox.alert('Chyba: Soubor je příliš velký. Maximální velikost je 10 MB.');
                $(this).val(''); return;
            }
            const formData = new FormData();
            formData.append('file', file);
            const label = $(this).closest('.form-group').find('label');
            const originalLabel = label.text();
            label.text('Nahrávám soubor...');
            $(this).prop('disabled', true);

            fetch(uploadUrl, {
                method: 'POST', body: formData,
                headers: { 'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content') }
            })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    $('#msignaturedocument-document_user_named').val(data.fileName);
                    $('#temp_file_path').val(data.filePath);
                    $('#original_file_name').val(data.fileName);
                    $('#after-upload').removeClass('d-none');
                    fileInput.prop('disabled', true);
                    fetch(previewUrl+"?path="+encodeURIComponent(data.filePath))
                        .then(response => response.text())
                        .then(html => {
                            $('#pdf-preview-container').removeClass('d-none');
                            $('#pdf-preview-container').html(html);
                            initializeAllPdfSliders();
                        })
                        .catch(err => {
                            console.error('Preview fetch error:', err);
                            $('#pdf-preview-container').removeClass('d-none');
                            $('#pdf-preview-container').html('<div class="alert alert-danger">Náhled se nepodařilo načíst.</div>');
                        });
                } else {
                    $('#pdf-preview-container').addClass('d-none');
                    bootbox.alert('Chyba při nahrávání: ' + data.error);
                    fileInput.prop('disabled', false);
                }
            })
            .catch(error => {
                console.error('Upload error:', error);
                bootbox.alert('Došlo k neočekávané chybě při nahrávání souboru.');
                fileInput.prop('disabled', false);
            })
            .finally(() => {
                label.text(originalLabel);
            });
        });
    }

    // Placeholder preview handlers. The preview must match the exact convention
    // the click will use: signatures are anchored bottom-left at the cursor,
    // variable/manual boxes top-left. Otherwise the box jumps on click.
    let placeholderHeight = 0;
    let placeholderBottomAnchored = true;
    $('#pdf-preview-container').on('mouseenter', '.pdf-page img', function(e) {
        const img = $(this);
        const pageElement = img.closest('.pdf-page');
        const original_width_mm = pageElement.data('original-width-mm');
        const original_height_mm = pageElement.data('original-height-mm');
        const displayed_width_px = img.width();
        const displayed_height_px = img.height();
        placeholderBottomAnchored = getActivePlacementType() === 'sign';
        const marker_width_mm = placeholderBottomAnchored ? 60 : 80;
        const marker_height_mm = placeholderBottomAnchored ? 15 : 8;
        const marker_width_px = (marker_width_mm / original_width_mm) * displayed_width_px;
        const marker_height_px = (marker_height_mm / original_height_mm) * displayed_height_px;
        placeholderHeight = marker_height_px;

        placeholder.css({
            width: marker_width_px + 'px',
            height: marker_height_px + 'px',
        }).show();

    }).on('mouseleave', '.pdf-page img', function(e) {
        placeholder.hide();
    }).on('mousemove', '.pdf-page img', function(e) {
        placeholder.css({
            left: e.pageX + 'px',
            top: (placeholderBottomAnchored ? (e.pageY - placeholderHeight) : e.pageY) + 'px'
        });
    });

    // 2. Handler for adding NEW markers (delegated for AJAX content). Branches
    //    on the active placement type: signature, entity variable, or manual text.
    $('#pdf-preview-container').on('click', '.pdf-page img', function(e) {
        const img = $(this);
        const pageElement = img.closest('.pdf-page');
        markerCounter++;
        const markerId = markerCounter;
        const offset = img.offset();
        const x_pixels = e.pageX - offset.left;
        const y_pixels = e.pageY - offset.top;
        const original_width_mm = pageElement.data('original-width-mm');
        const original_height_mm = pageElement.data('original-height-mm');
        const displayed_width_px = img.width();
        const displayed_height_px = img.height();
        const page_number = pageElement.data('page_number');
        const x_mm = (x_pixels / displayed_width_px) * original_width_mm;
        const y_mm = (y_pixels / displayed_height_px) * original_height_mm;

        const placementType = getActivePlacementType();
        if (placementType === 'variable' || placementType === 'manual') {
            placeVariableMarker(placementType, pageElement, markerId, page_number, x_mm, y_mm,
                x_pixels, y_pixels, original_width_mm, displayed_width_px);
            refreshSetSignsButton();
            return;
        }

        // Signature marker: pos_y is treated as the box bottom (top = y - height).
        const marker_width_mm = 60;
        const marker_height_mm = 15;
        const marker_width_px = (marker_width_mm / original_width_mm) * displayed_width_px;
        const marker_height_px = (marker_height_mm / original_height_mm) * displayed_height_px;
        const marker_left_px = x_pixels;
        const marker_top_px = y_pixels - marker_height_px;

        const marker = $('<div style="text-align:center;color:red;">Podpis '+markerId+'</div>')
            .addClass('click-marker').attr('id', 'marker-' + markerId)
            .css({
                position: 'absolute', left: marker_left_px + 'px', top: marker_top_px + 'px',
                width: marker_width_px + 'px', height: marker_height_px + 'px',
                border: '1px solid red', 'pointer-events': 'auto', cursor: 'move'
            });
        pageElement.append(marker);

        markers[markerId] = { id: markerId, page: page_number, x: x_mm, y: y_mm, width: marker_width_mm, height: marker_height_mm };
        var signatures_count = $('.marker-info[data-marker-kind="sign"]').length;

        // Multi-document mode (add_to_package): emit signer_uuid instead of
        // per-sign person fields. Falls back to legacy person inputs if the
        // signer roster is not provided on the page.
        const signers = window.MSIGN_SIGNERS || null;
        let infoCard;
        if (signers && signers.length) {
            const activeSignerUuid = $('#active-signer').val() || signers[0].uuid;
            const signerOptions = signers.map(function (s) {
                const sel = s.uuid === activeSignerUuid ? ' selected' : '';
                return '<option value="' + s.uuid + '"' + sel + '>' + s.name + ' (' + (s.email || '') + ')</option>';
            }).join('');
            infoCard = "<div class=\"card mb-2 marker-info\" data-marker-kind=\"sign\" id=\"marker-info-" + markerId + "\">" +
                "<div class=\"card-body p-2\">" +
                    "<button class=\"btn btn-sm btn-phoenix-danger remove-marker-btn float-end\" data-marker-id=\"" + markerId + "\">Odebrat</button>" +
                    "<p class=\"mb-1 small\"><strong>Podpis " + markerId + "</strong>: Strana " + page_number + ", X: " + x_mm.toFixed(2) + "mm, Y: " + y_mm.toFixed(2) + "mm</p>" +
                    "<label class=\"form-label\">Podepisující</label>" +
                    "<select name=\"MsignatureDocumentSign[" + markerId + "][signer_uuid]\" class=\"form-select validate-for-empty\">" + signerOptions + "</select>" +
                    "<input type=\"hidden\" name=\"MsignatureDocumentSign[" + markerId + "][page_number]\" value=\"" + page_number + "\">" +
                    "<input type=\"hidden\" name=\"MsignatureDocumentSign[" + markerId + "][pos_x]\" value=\"" + x_mm.toFixed(2) + "\">" +
                    "<input type=\"hidden\" name=\"MsignatureDocumentSign[" + markerId + "][pos_y]\" value=\"" + y_mm.toFixed(2) + "\">" +
                "</div>" +
            "</div>";
        } else {
            infoCard = "<div class=\"card mb-2 marker-info\" data-marker-kind=\"sign\" id=\"marker-info-" + markerId + "\">" +
                "<div class=\"card-body p-2\">" +
                    "<button class=\"btn btn-sm btn-phoenix-danger remove-marker-btn float-end\" data-marker-id=\"" + markerId + "\">Odebrat</button>" +
                    "<p class=\"mb-1 small\"><strong>Podpis " + markerId + "</strong>: Strana " + page_number + ", X: " + x_mm.toFixed(2) + "mm, Y: " + y_mm.toFixed(2) + "mm</p>" +
                    "<label>Jméno osoby</label>" +
                    "<input type=\"text\" name=\"MsignatureDocumentSign[" + markerId + "][person_name]\" class=\"form-control validate-for-empty\" " + (signatures_count == 0 ? "value=\"" + $('#contact_default_name').val() + "\"" : "") + "><br>" +
                    "<label>E-mail</label>" +
                    "<input type=\"text\" name=\"MsignatureDocumentSign[" + markerId + "][person_email]\" class=\"form-control validate-for-empty\" " + (signatures_count == 0 ? "value=\"" + $('#contact_default_email').val() + "\"" : "") + "><br>" +
                    "<label>Telefon</label>" +
                    "<input type=\"text\" name=\"MsignatureDocumentSign[" + markerId + "][person_phone]\" class=\"form-control validate-for-empty\" " + (signatures_count == 0 ? "value=\"" + $('#contact_default_phone').val() + "\"" : "") + "><br>" +
                    "<input type=\"hidden\" name=\"MsignatureDocumentSign[" + markerId + "][page_number]\" value=\"" + page_number + "\">" +
                    "<input type=\"hidden\" name=\"MsignatureDocumentSign[" + markerId + "][pos_x]\" value=\"" + x_mm.toFixed(2) + "\">" +
                    "<input type=\"hidden\" name=\"MsignatureDocumentSign[" + markerId + "][pos_y]\" value=\"" + y_mm.toFixed(2) + "\">" +
                "</div>" +
            "</div>";
        }
        $('#signatures-settings').append(infoCard);
        refreshSetSignsButton();
    });

    // Place a variable/manual text marker (top-left convention) plus its editor
    // card. type is 'manual' or 'variable'; a variable whose key is the special
    // items key becomes a resizable table placeholder with column checkboxes.
    function placeVariableMarker(type, pageElement, markerId, page_number, x_mm, y_mm,
                                 x_pixels, y_pixels, original_width_mm, displayed_width_px) {
        let key = 'manual';
        let isItems = false;
        if (type !== 'manual') {
            const sel = document.getElementById('active-variable');
            key = sel ? sel.value : '';
            isItems = isItemsKey(key);
        }
        // Tables want more room by default than a single value.
        const marker_width_mm = isItems ? 170 : 80;
        const marker_width_px = (marker_width_mm / original_width_mm) * displayed_width_px;

        let displayText, headline, editorHtml, labelIsHtml = false;
        if (type === 'manual') {
            displayText = ($('#active-manual-text').val() || '').trim();
            headline = 'Vlastní text';
            editorHtml =
                "<label class=\"form-label\">Vlastní text</label>" +
                "<input type=\"text\" name=\"MsignatureDocumentVariable[" + markerId + "][value]\" class=\"form-control validate-for-empty var-manual-text\" value=\"" + $('<div>').text(displayText).html() + "\">" +
                "<input type=\"hidden\" name=\"MsignatureDocumentVariable[" + markerId + "][variable_key]\" value=\"manual\">";
        } else {
            const selHtml = "<label class=\"form-label\">Proměnná</label>" +
                "<select name=\"MsignatureDocumentVariable[" + markerId + "][variable_key]\" class=\"form-select var-key-select\">" + buildVariableOptionsHtml(key) + "</select>";
            if (isItems) {
                const defaults = itemsCfg().defaults || {};
                headline = buildItemsPlaceholderHtml(defaults);
                labelIsHtml = true;
                editorHtml = selHtml + itemsCheckboxesHtml(markerId, defaults);
            } else {
                displayText = variableValueForKey(key);
                const sel = document.getElementById('active-variable');
                headline = sel && sel.selectedIndex >= 0 ? sel.options[sel.selectedIndex].text : key;
                editorHtml = selHtml;
            }
        }

        const cfg = msignStyleCfg();
        const marker = $('<div class="var-marker"></div>')
            .addClass('click-marker').attr('id', 'marker-' + markerId)
            .css({
                position: 'absolute', left: x_pixels + 'px', top: y_pixels + 'px',
                width: marker_width_px + 'px',
                color: cfg.defaultColor, fontSize: cfg.defaultSize + 'px', 'font-family': cssFontFamily(cfg.defaultFont),
                lineHeight: '1.2', border: '1px dashed ' + variableBorderColor(type), 'pointer-events': 'auto', cursor: 'move'
            });
        const labelSpan = $('<span class="marker-label"></span>');
        if (labelIsHtml) { labelSpan.html(headline); } else { labelSpan.text(displayText || headline); }
        marker.append(labelSpan);
        marker.append(makeResizeHandle(variableBorderColor(type)));
        pageElement.append(marker);

        const infoCard = "<div class=\"card mb-2 marker-info\" data-marker-kind=\"variable\" id=\"marker-info-" + markerId + "\">" +
            "<div class=\"card-body p-2\">" +
                "<button class=\"btn btn-sm btn-phoenix-danger remove-marker-btn float-end\" data-marker-id=\"" + markerId + "\">Odebrat</button>" +
                "<p class=\"mb-1 small\"><strong>Proměnná</strong>: Strana " + page_number + ", X: " + x_mm.toFixed(2) + "mm, Y: " + y_mm.toFixed(2) + "mm</p>" +
                editorHtml +
                buildStyleControls(markerId) +
                "<input type=\"hidden\" name=\"MsignatureDocumentVariable[" + markerId + "][page_number]\" value=\"" + page_number + "\">" +
                "<input type=\"hidden\" name=\"MsignatureDocumentVariable[" + markerId + "][pos_x]\" value=\"" + x_mm.toFixed(2) + "\">" +
                "<input type=\"hidden\" name=\"MsignatureDocumentVariable[" + markerId + "][pos_y]\" value=\"" + y_mm.toFixed(2) + "\">" +
                "<input type=\"hidden\" name=\"MsignatureDocumentVariable[" + markerId + "][width_mm]\" value=\"" + marker_width_mm + "\">" +
            "</div>" +
        "</div>";
        $('#signatures-settings').append(infoCard);
        markers[markerId] = { id: markerId, page: page_number, x: x_mm, y: y_mm, kind: 'variable' };
        applyMarkerStyle(markerId, cfg.defaultFont, cfg.defaultSize, cfg.defaultColor);
    }

    function refreshSetSignsButton() {
        const sign_count = $('.marker-info[data-marker-kind="sign"]').length;
        // Templates may allow documents with variables only (no signature).
        const allowVariableOnly = window.MSIGN_ALLOW_VARIABLE_ONLY === true;
        const any_count = $('.marker-info').length;
        const ok = sign_count > 0 || (allowVariableOnly && any_count > 0);
        $('#set-signs-button').prop('disabled', !ok);
    }

    // The on-page label span for a card's marker (new or existing).
    function markerLabelFor(markerId) {
        return $('#marker-' + markerId + ' .marker-label, #existing-marker-' + markerId + ' .marker-label');
    }

    // Keep a marker's on-page text in sync when its editor value changes.
    $('#signatures-settings').on('change', '.var-key-select', function () {
        const card = $(this).closest('.marker-info');
        const markerId = card.attr('id').replace('marker-info-', '');
        const key = $(this).val();
        const label = markerLabelFor(markerId);
        if (isItemsKey(key)) {
            // Switched to the items table: ensure column checkboxes exist and
            // draw the placeholder table.
            let options;
            if (!card.find('.var-items-options').length) {
                options = itemsCfg().defaults || {};
                $(this).after(itemsCheckboxesHtml(markerId, options));
            } else {
                options = itemsOptionsFromCard(card);
            }
            label.html(buildItemsPlaceholderHtml(options));
        } else {
            card.find('.var-items-options').remove();
            label.text(variableValueForKey(key) || $(this).find('option:selected').text());
        }
    }).on('change', '.var-items-col', function () {
        const card = $(this).closest('.marker-info');
        const markerId = card.attr('id').replace('marker-info-', '');
        markerLabelFor(markerId).html(buildItemsPlaceholderHtml(itemsOptionsFromCard(card)));
    }).on('input', '.var-manual-text', function () {
        const card = $(this).closest('.marker-info');
        const markerId = card.attr('id').replace('marker-info-', '');
        $('#marker-' + markerId + ' .marker-label, #existing-marker-' + markerId + ' .marker-label').text($(this).val() || 'Vlastní text');
    }).on('change input', '.var-font, .var-size, .var-color', function () {
        const card = $(this).closest('.marker-info');
        const markerId = card.attr('id').replace('marker-info-', '');
        applyMarkerStyle(markerId, card.find('.var-font').val(), card.find('.var-size').val(), card.find('.var-color').val());
    });

    // Toggle the visible picker (signer / variable / manual) with the type radios.
    $(document).on('change', 'input[name="placement_type"]', function () {
        const type = getActivePlacementType();
        $('.placement-picker').addClass('d-none');
        $('#picker-' + type).removeClass('d-none');
        placeholder.text(type === 'sign' ? 'Podpis' : 'Text');
    });

    // 3. Handler for removing NEW signatures
    const signaturesSettings = $('#signatures-settings');
    signaturesSettings.on('click', '.remove-marker-btn', function() {
        const markerId = $(this).data('marker-id');
        if (markers[markerId]) {
            delete markers[markerId];
            $('#marker-' + markerId).remove();
            $(this).closest('.marker-info').remove();
        }
        refreshSetSignsButton();
    });

    // 4. Handler for removing EXISTING signatures on update page
    $(document).on('click', '.remove-existing-marker-btn', function(e) {
        e.preventDefault();
        const uuid = $(this).data('marker-uuid');
        console.log('REMOVE: Button clicked for UUID:', uuid);
        console.log('REMOVE: Attempting to remove selector:', '#existing-marker-' + uuid);
        if (uuid) {
            const infoCard = $('#marker-info-' + uuid);
            infoCard.find('.destroy-flag').val('1');
            infoCard.hide();
            $('#existing-marker-' + uuid).remove();
        }
    });

    // 4b. Drag-to-relocate and resize placed markers (editor pages only). Works
    //     for both freshly placed (.click-marker) and already-saved
    //     (.existing-click-marker) markers; on drop we recompute the mm geometry,
    //     honouring the per-kind anchor convention, and write it back to the
    //     hidden inputs + card label.
    let drag = null;
    let resize = null;

    function commitMarkerPosition(marker, pageElement) {
        const original_width_mm = pageElement.data('original-width-mm');
        const original_height_mm = pageElement.data('original-height-mm');
        const img = pageElement.find('img');
        const displayed_width_px = img.width();
        const displayed_height_px = img.height();
        if (!displayed_width_px || !displayed_height_px) return;

        const key = markerKey(marker);
        if (key === null) return;
        const card = $('#marker-info-' + key);
        if (!card.length) return;
        const kind = card.data('marker-kind');

        const left_px = parseFloat(marker.css('left')) || 0;
        const top_px = parseFloat(marker.css('top')) || 0;
        // Signatures store pos_y as the box BOTTOM; variables as the TOP-LEFT.
        const pos_y_px = kind === 'sign' ? top_px + marker.outerHeight() : top_px;
        const x_mm = (left_px / displayed_width_px) * original_width_mm;
        const y_mm = (pos_y_px / displayed_height_px) * original_height_mm;

        card.find('input[name$="[pos_x]"]').val(x_mm.toFixed(2));
        card.find('input[name$="[pos_y]"]').val(y_mm.toFixed(2));

        // Keep the in-memory registry (new markers) in sync.
        if (markers[key]) { markers[key].x = x_mm; markers[key].y = y_mm; }

        // Refresh the visible "Strana X, X: ..mm, Y: ..mm" label.
        const label = card.find('p.small').first();
        if (label.length) {
            const page = card.find('input[name$="[page_number]"]').val() || pageElement.data('page_number');
            const strong = label.find('strong').first().text() || (kind === 'sign' ? 'Podpis' : 'Proměnná');
            label.html('<strong>' + strong + '</strong>: Strana ' + page +
                ', X: ' + x_mm.toFixed(2) + 'mm, Y: ' + y_mm.toFixed(2) + 'mm');
        }
    }

    function commitMarkerWidth(marker, pageElement) {
        const original_width_mm = pageElement.data('original-width-mm');
        const img = pageElement.find('img');
        const displayed_width_px = img.width();
        if (!displayed_width_px) return;
        const key = markerKey(marker);
        if (key === null) return;
        const card = $('#marker-info-' + key);
        if (!card.length) return;
        const width_mm = (marker.outerWidth() / displayed_width_px) * original_width_mm;
        card.find('input[name$="[width_mm]"]').val(width_mm.toFixed(2));
    }

    if (IS_EDITOR) {
        // Resize grip takes precedence over move: stop the mousedown from also
        // starting a drag.
        $(document).on('mousedown', '.marker-resize-handle', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const marker = $(this).closest('.click-marker, .existing-click-marker');
            const pageElement = marker.closest('.pdf-page');
            const img = pageElement.find('img');
            resize = {
                marker: marker,
                pageElement: pageElement,
                imgW: img.width(),
                startX: e.pageX,
                startWidth: marker.outerWidth(),
                startLeft: parseFloat(marker.css('left')) || 0,
                changed: false
            };
            marker.css('opacity', 0.65);
        });
        $(document).on('mousedown', '.pdf-page .click-marker, .pdf-page .existing-click-marker', function (e) {
            e.preventDefault();
            const marker = $(this);
            const pageElement = marker.closest('.pdf-page');
            const img = pageElement.find('img');
            const imgOffset = img.offset();
            drag = {
                marker: marker,
                pageElement: pageElement,
                imgOffset: imgOffset,
                imgW: img.width(),
                imgH: img.height(),
                grabX: (e.pageX - imgOffset.left) - (parseFloat(marker.css('left')) || 0),
                grabY: (e.pageY - imgOffset.top) - (parseFloat(marker.css('top')) || 0),
                moved: false
            };
            marker.css('opacity', 0.65);
        });
        $(document).on('mousemove', function (e) {
            if (resize) {
                resize.changed = true;
                let w = resize.startWidth + (e.pageX - resize.startX);
                w = Math.max(15, Math.min(w, resize.imgW - resize.startLeft));
                resize.marker.css('width', w + 'px');
                return;
            }
            if (!drag) return;
            drag.moved = true;
            let left = (e.pageX - drag.imgOffset.left) - drag.grabX;
            let top = (e.pageY - drag.imgOffset.top) - drag.grabY;
            left = Math.max(0, Math.min(left, drag.imgW));
            top = Math.max(0, Math.min(top, drag.imgH));
            drag.marker.css({ left: left + 'px', top: top + 'px' });
        });
        $(document).on('mouseup', function () {
            if (resize) {
                resize.marker.css('opacity', '');
                if (resize.changed) { commitMarkerWidth(resize.marker, resize.pageElement); }
                resize = null;
                return;
            }
            if (!drag) return;
            drag.marker.css('opacity', '');
            if (drag.moved) {
                commitMarkerPosition(drag.marker, drag.pageElement);
            }
            drag = null;
        });
    }

    // 5. Form Validation Logic
    const form = signaturesSettings.closest('form');
    if (form.length) {
        form.on('submit', function(e) {
            let isValid = true;
            const inputsToValidate = form.find('.marker-info:visible .validate-for-empty'); // Only validate visible cards
            inputsToValidate.removeClass('is-invalid');
            form.find('.validation-summary').remove();
            inputsToValidate.each(function() {
                const input = $(this);
                if (input.val().trim() === '') {
                    isValid = false;
                    input.addClass('is-invalid');
                }
            });
            if (!isValid) {
                e.preventDefault();
                const errorSummary = $('<div class="alert alert-danger validation-summary mt-3">Prosím, vyplňte všechna povinná pole (jméno, e-mail, telefon) u každého podpisu.</div>');
                const cardBody = form.closest('.card-body');
                if(cardBody.length) {
                    cardBody.prepend(errorSummary);
                } else {
                    form.prepend(errorSummary);
                }
            }
        });
    }
});